import Actions from 'actions'
import { of } from 'rxjs'
import { trackEvent } from 'utils/analyticsUtils'

export const buildBulkInviteUploadKeySuffix = (uploadId, fileName) => `${uploadId}/${fileName}`

export const handleBulkInviteError = (error, uploadId = null) => {
  const errorData = error?.response?.data || error?.data || {}
  const statusCode = error?.response?.status || error?.status || 500

  trackEvent('bulk invite - form submitted - error', {
    error: error?.message,
    statusCode,
    uploadId,
    invalidRows: errorData?.validations?.rows?.length
  })

  if (statusCode === 422 && errorData?.validations) {
    trackEvent('bulk invite - validation failed', {
      invalidRows: errorData.validations.rows?.length,
      statusCode
    })
    return of(
      Actions.uploadBulkInviteFormFailed({
        errors: errorData.validations,
        statusCode
      })
    )
  }

  if (statusCode === 400) {
    if (errorData?.validations) {
      trackEvent('bulk invite - validation failed', {
        invalidRows: errorData.validations.rows?.length,
        statusCode
      })
      return of(
        Actions.uploadBulkInviteFormFailed({
          errors: errorData.validations,
          statusCode
        })
      )
    }

    if (errorData?.message) {
      return of(
        Actions.uploadBulkInviteFormFailed({
          errors: { form: errorData.message },
          statusCode
        })
      )
    }
  }

  return of(
    Actions.uploadBulkInviteFormFailed({
      errors: { form: errorData?.message || 'upload-failed' },
      statusCode
    })
  )
}
